import { AvailableMission } from '@web/common';
import { MissionType } from '@prisma/client';
import { DateTime } from 'luxon';

export const isQuestionnaireMission = (mission: AvailableMission) =>
  mission.type === MissionType.RegularQuestionnaire ||
  mission.type === MissionType.RegularQuestionnaireStreak;

export const isWithinDetectionWindow = (
  mission: AvailableMission,
  detectionWindowStart: DateTime,
) =>
  !mission.startDate ||
  DateTime.fromJSDate(mission.startDate) >= detectionWindowStart;
